import { takeEvery, select, put } from 'redux-saga/effects'
import difference from 'lodash/difference'

import { SCOPE_REVIEWS } from 'app/constants/reviews'
import { updateUserTeams, updateUserTeamsSuccessForMicroactions, updateUserTeamsSuccessForReviews } from '../actions'
import { getPendingObject, getOrganizationUsersOrganizationId, getOrganizationTeamsById } from '../selectors'

export function* handleUpdateUserTeamsSuccess() {
  const pendingObject = yield select(getPendingObject)
  const organizationId = yield select(getOrganizationUsersOrganizationId)
  const organizationTeamsList = yield select(getOrganizationTeamsById(organizationId))
  const newTeams = difference(pendingObject.teams.toJS(), organizationTeamsList.toJS())
  const { teams, userId } = pendingObject
  const payloadNew = { userId, teams, newTeams, organizationId, organizationTeams: organizationTeamsList }
  if (pendingObject.scope === SCOPE_REVIEWS) {
    yield put(updateUserTeamsSuccessForReviews(payloadNew))
  } else {
    yield put(updateUserTeamsSuccessForMicroactions(payloadNew))
  }
}

export default function* takeEveryUpdateUserTeams() {
  yield* [takeEvery(updateUserTeams.success.toString(), handleUpdateUserTeamsSuccess)]
}
